import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { VideoPlane } from '@Components/BigBrowse/bb2/meshes2/cards/VideoPlane';
import { a } from '@react-spring/three';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React, { useMemo } from 'react';

import { ImageMaterialRectangle } from '../primitives/ImageMaterialRectangle';

type IProps = {
  gridCard: GridCard<
    PlaneTypes.Header_Background | PlaneTypes.Section_Background
  >;
};

const ConcessionSectionBackground: FC<IProps> = ({ gridCard }) => {
  const { data } = gridCard;
  const imageUrl = data?.backgroundImageUrl;
  const { size } = gridCard;

  const backgroundVideo = useMemo(
    () =>
      gridCard.data?.backgroundMedia?.items.find(
        (i) => i.mediaType === 'Mp4VideoClip'
      ),
    [gridCard]
  );

  if (backgroundVideo) {
    return (
      <VideoPlane
        position={{ x: 0, y: gridCard.worldPosition.y }}
        size={size}
        src={backgroundVideo.url}
        zPosition={PLANE_DEFAULT_Z - 1}
        sourceSize={{
          width: backgroundVideo.width,
          height: backgroundVideo.height,
        }}
      />
    );
  }

  return (
    <a.mesh position={[0, gridCard.worldPosition.y, PLANE_DEFAULT_Z - 1]}>
      <planeBufferGeometry
        attach='geometry'
        args={[size?.width, size?.height]}
      />
      {data?.backgroundMode === 'StretchedImage' ? (
        <ImageMaterialRectangle imageUrl={imageUrl!} planeSize={size} />
      ) : (
        <meshBasicMaterial
          color={
            data?.backgroundMode === 'Colour' ? data?.backgroundColour : 'white'
          }
        />
      )}
    </a.mesh>
  );
};

export default observer(ConcessionSectionBackground);
